<template>
  <div>
      <v-toolbar dense
                 src="https://www.cellmark.com/wp-content/uploads/2019/09/printing-and-writing-papers.jpg"
      >
        <v-spacer></v-spacer>
        <v-btn
          @click="exportExc"
          outlined
          color="error"
        >
          Excel export
        </v-btn>
        <v-dialog
          max-width="500"
          v-model="exportDialog">
          <ExportInvoices
            v-if="exportDialog"
            @exported="exportDialog = false"
          ></ExportInvoices>
        </v-dialog>
      </v-toolbar>
    <template>
      <v-card>
        <v-card-title>
          Faktury
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledat"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="invoices"
          :search="search"
          :loading="loading"
        >
          <template v-slot:item.show="{ item }">
            <v-icon
              @click="showInvoice(item, false)"
            >mdi-eye</v-icon>
            <v-icon
              @click="showInvoice(item, true)"
            >mdi-download</v-icon>
          </template>
        </v-data-table>
        <v-dialog v-model="invoiceDialog">
          <v-card>
            <InvoiceView
              v-if="invoiceDialog" :invoice="displayedInvoice"
            ></InvoiceView>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </div>
</template>

<script>
import InvoiceView from '../../components/InvoiceView'
import ExportInvoices from '@/components/forms/admin/ExportInvoices.vue'
export default {
  name: 'InvoiceSystem',
  components: { ExportInvoices, InvoiceView },
  data () {
    return {
      loading: true,
      invoiceDialog: false,
      displayedInvoice: null,
      invoices: [],
      search: null,
      exportDialog: false,
      headers: [
        { text: 'Číslo faktury', value: 'id', align: 'start', sortable: true },
        { text: 'Vytvořena', value: 'createdStr' },
        { text: 'Uživatel', value: 'user' },
        { text: 'Bez DPH', value: 'priceWithoutDPH' },
        { text: 'S DPH', value: 'priceWithDPH' },
        { text: 'Částka celkem', value: 'priceTotal' },
        { text: 'Zobrazit', value: 'show', sortable: false }
      ]
    }
  },
  methods: {
    exportExc () {
      this.exportDialog = true
    },
    initialize () {
      this.loading = true
      this.$http.get('/admin/invoices')
        .then(response => {
          this.invoices = this.keysToCamelCase(response.data)
            .filter(invoice => invoice.transaction)
            .map(invoice => {
              const c = new Date(invoice.createdAt)
              invoice.createdStr = `${c.getDate()}.${c.getMonth() + 1}.${c.getFullYear()}
                ${c.getHours()}:${c.getMinutes()}:${c.getSeconds() < 10 ? '0' + c.getSeconds() : c.getSeconds()}`
              invoice.priceWithoutDPH = (Math.round((invoice.transaction.price / 1.15) * 100) / 100).toFixed(2)
              invoice.priceWithDPH = (invoice.transaction.price - (Math.round((invoice.transaction.price / 1.15) * 100) / 100)).toFixed(2)
              invoice.priceTotal = invoice.transaction.price
              if (invoice.transaction.user.companyName === null) {
                invoice.user = invoice.transaction.user.firstName + ' ' + invoice.transaction.user.lastName
              } else {
                invoice.user = invoice.transaction.user.firstName + ' ' + invoice.transaction.user.lastName + ' (' + invoice.transaction.user.companyName + ')'
              }
              return invoice
            })
          this.loading = false
        })
        .catch(err => { console.log(err) })
    },
    showInvoice (item, print) {
      this.$http({
        method: 'POST',
        url: '/admin/invoices/download',
        responseType: 'blob',
        data: {
          invoice_id: item.id
        }
      })
        .then(response => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'Faktura ' + item.id + '.pdf')
          document.body.appendChild(fileLink)

          print ? fileLink.click() : window.open(fileURL)
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created () {
    this.initialize()
  }
}
</script>

<style scoped>

</style>
